import { render, staticRenderFns } from "./member-address-form.vue?vue&type=template&id=d2691df2&"
import script from "./member-address-form.vue?vue&type=script&lang=js&"
export * from "./member-address-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports